import script from "./VParticipantsDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./VParticipantsDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./VParticipantsDropdown.vue?vue&type=style&index=0&id=69583382&lang=sass"

const __exports__ = script;

export default __exports__